import { Leader } from "@outschool/gql-backend-generated";
import {
  FollowedTeachersQuery,
  FollowedTeachersQueryVariables,
} from "@outschool/gql-frontend-generated";
import { useQueryWithPreviousData } from "@outschool/ui-apollo";
import { useSession } from "@outschool/ui-auth";
import React from "react";

import FollowedTeachers from "./FollowedUserQueries";

export function useFollowedUsers() {
  const { isLoggedIn } = useSession();
  const { loading, data } = useQueryWithPreviousData<
    FollowedTeachersQuery,
    FollowedTeachersQueryVariables
  >(FollowedTeachers, {
    skip: !isLoggedIn,
  });
  return { loading, followedUsers: data?.currentUser?.followedUsers ?? [] };
}

export function useIsTeacherFollowedByCurrentUser(
  teacher: Pick<Leader, "uid">
) {
  const { followedUsers } = useFollowedUsers();
  return React.useMemo(
    () => followedUsers.some(fu => fu.leader.uid === teacher.uid),
    [teacher?.uid, followedUsers]
  );
}
